import { AlertTriangle, CalendarClock } from 'lucide-react';

const MESES = ['ENE', 'FEB', 'MAR', 'ABR', 'MAY', 'JUN', 'JUL', 'AGO', 'SEP', 'OCT', 'NOV', 'DIC'];

export function plazoDeLaOrdenanza(
  periodo: string,
  hoy: string,
): { limite: string; diasDeRetraso: number } {
  const [anio, mes] = periodo.split('-').map(Number) as [number, number];
  const limite = new Date(Date.UTC(anio, mes, 5));
  const [a, m, d] = hoy.split('-').map(Number) as [number, number, number];
  const dia = Date.UTC(a, m - 1, d);
  const diasDeRetraso = Math.max(0, Math.round((dia - limite.getTime()) / 86_400_000));
  return { limite: limite.toISOString().slice(0, 10), diasDeRetraso };
}

function enDia(iso: string): string {
  const [anio, mes, dia] = iso.split('-');
  return `${Number(dia)} ${MESES[Number(mes) - 1] ?? mes} ${anio}`;
}

function hoyLocal(): string {
  const ahora = new Date();
  const dosCifras = (n: number) => String(n).padStart(2, '0');
  return `${ahora.getFullYear()}-${dosCifras(ahora.getMonth() + 1)}-${dosCifras(ahora.getDate())}`;
}

export function AvisoDelPlazo({ periodo, hoy = hoyLocal() }: { periodo: string; hoy?: string }) {
  const { limite, diasDeRetraso } = plazoDeLaOrdenanza(periodo, hoy);
  if (diasDeRetraso === 0) {
    return (
      <p className="flex items-center gap-2 text-[11px] font-semibold uppercase text-armazon-500">
        <CalendarClock className="size-4 shrink-0" aria-hidden />
        La ordenanza pide facturarlo hasta el {enDia(limite)}
      </p>
    );
  }
  return (
    <p
      role="status"
      className="flex items-start gap-2 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-[11px] font-semibold uppercase leading-relaxed text-amber-800"
    >
      <AlertTriangle className="mt-px size-4 shrink-0" aria-hidden />
      <span>
        Fuera de plazo: la ordenanza pide facturar dentro de los primeros cinco días del mes
        siguiente, hasta el {enDia(limite)}. Van {diasDeRetraso}{' '}
        {diasDeRetraso === 1 ? 'día' : 'días'} de retraso.
      </span>
    </p>
  );
}
